import { Store } from "@core/storage/storage";
import { NotificationManager } from "@domain/notification/notification-manager";

import { UserManager } from "@domain/user/user-manager";
import { isNil, isNotNil } from "@utils/assert";
import { Observable, observable } from "micro-observables";

export type LastUnreadCounts = Record<string, number | undefined>;

export class NotificationBadgeManager {
	private readonly _lastUnreadCount = observable<number>(-1);
	shouldDisplayBadge: Observable<boolean>;

	constructor(
		private readonly notificationManager: NotificationManager,
		private readonly userManager: UserManager,
		private readonly store: Store<LastUnreadCounts>,
	) {
		this.shouldDisplayBadge = Observable.merge([this.notificationManager.unreadCount, this._lastUnreadCount]).select(
			([unreadCount, lastUnreadCount]) => unreadCount > 0 && lastUnreadCount !== unreadCount,
		);
		this.userManager.user.subscribe(async user => {
			const ptId = user?.id;
			const storedUnreadCounts = this.store.getItem();
			let lastUnreadCount = -1;
			if (isNotNil(ptId) && isNotNil(storedUnreadCounts) && isNotNil(storedUnreadCounts[ptId])) {
				lastUnreadCount = storedUnreadCounts[ptId];
			}
			this._lastUnreadCount.set(lastUnreadCount);
		});
	}

	saveLastUnreadCount(): void {
		const unreadCount = this.notificationManager.unreadCount.get();
		const ptId = this.userManager.user.get()?.id;
		if (isNil(ptId)) {
			return;
		}
		const previousLastUnreadCounts = this.store.getItem();
		this.store.setItem({ ...previousLastUnreadCounts, [ptId]: unreadCount });
		this._lastUnreadCount.set(unreadCount);
	}
}
